import { Lock } from '@mui/icons-material';
import { SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import { useModalV2 } from 'common/modal/hooks/useModalV2';
import { useUpdateCandidateMutation } from 'generated-graphql/hooks/apollo-hooks';

type CandidateProfileAnalysisUnlockProps = {
  candidateId: string;
};

const buttonStyle: SxProps = {
  p: 0
};

export const CandidateProfileAnalysisUnlock: React.FC<
  CandidateProfileAnalysisUnlockProps
> = ({ candidateId }) => {
  const { openModal } = useModalV2();

  const [updateCandidate] = useUpdateCandidateMutation();

  const onConfirm = async () => {
    await updateCandidate({
      variables: {
        input: { id: candidateId, isLocked: false }
      }
    });
  };

  const handleUnlock = async () => {
    openModal({
      title: 'Unlock candidate?',
      subtitle: 'This will allow you to change the applicant’s status.',
      primaryButtonText: 'Confirm',
      secondaryButtonText: 'Cancel',
      onPrimaryAction: onConfirm
    });
  };
  return (
    <Button variant="tertiary" onClick={handleUnlock} sx={buttonStyle}>
      <Lock />
      Status
    </Button>
  );
};
